// extracted by mini-css-extract-plugin
export var container = "styles-module--container--P3N6d";
export var imgBeAProvider = "styles-module--imgBeAProvider--eTY8d";
export var contentWrapper = "styles-module--contentWrapper--zGw7l";
export var signupButton = "styles-module--signupButton--WLVGC";